/**
 * Status Utility Functions
 * 
 * Re-exports all status-related utilities from focused modules.
 * This file maintains backwards compatibility - all existing imports will continue to work.
 * 
 * Modules:
 * - statusConfig.js: Status category/config functions
 * - progressUtils.js: Progress calculation
 * - statusManagement.js: Status CRUD, grouping, sorting
 * - colorUtils.js: Color generation utilities
 */

// Import all for default export and re-exports
import {
  getStatusCategory,
  getStatusConfig,
  toLegacyStatusConfig,
  isStatusCompleted,
  isStatusInProgress,
  isStatusNotStarted,
  isStatusBlocked,
  getCategoryConfig,
} from './statusConfig';

import { calculateProgress } from './progressUtils';

import {
  getTasksByCategory,
  groupTasksByStatus,
  generateStatusId,
  sortStatusesByCategory,
  findPreferredStatus,
  canDeleteStatus,
  getFallbackStatus,
} from './statusManagement';

import {
  STATUS_COLOR_PRESETS,
  getMostDistinctColor,
  getSuggestedStatusColor,
} from './colorUtils';

import { isWaitStatusReason } from '../../shared/ConditionsDropdown/utils/conditionWait';

/** Status pill copy while a mission is locked. Wait lives in the label. */
export function getLockedStatusLabel(lockReason) {
  if (isWaitStatusReason(lockReason)) {
    return `Locked: ${lockReason}`;
  }
  return 'Locked';
}

// Status configuration utilities
export {
  getStatusCategory,
  getStatusConfig,
  toLegacyStatusConfig,
  isStatusCompleted,
  isStatusInProgress,
  isStatusNotStarted,
  isStatusBlocked,
  getCategoryConfig,
};

// Progress calculation
export { calculateProgress };

// Status management utilities
export {
  getTasksByCategory,
  groupTasksByStatus,
  generateStatusId,
  sortStatusesByCategory,
  findPreferredStatus,
  canDeleteStatus,
  getFallbackStatus,
};

// Color utilities
export {
  STATUS_COLOR_PRESETS,
  getMostDistinctColor,
  getSuggestedStatusColor,
};

// Default export for backwards compatibility
export default {
  getStatusCategory,
  getStatusConfig,
  toLegacyStatusConfig,
  isStatusCompleted,
  isStatusInProgress,
  isStatusNotStarted,
  isStatusBlocked,
  getCategoryConfig,
  calculateProgress,
  getTasksByCategory,
  groupTasksByStatus,
  generateStatusId,
  sortStatusesByCategory,
  findPreferredStatus,
  canDeleteStatus,
  getFallbackStatus,
  STATUS_COLOR_PRESETS,
  getMostDistinctColor,
  getSuggestedStatusColor,
};
